import { render, staticRenderFns } from "./WebShopOptionsCategory.vue?vue&type=template&id=6464d91c"
import script from "./WebShopOptionsCategory.vue?vue&type=script&lang=js"
export * from "./WebShopOptionsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports